import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgBikeElectric = function SvgBikeElectric(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.563 12.594C.72 13.38.28 14.39.28 15.764a4.688 4.688 0 009.281.938h1.72l.222-.119c.62-.333.957-.83 1.249-1.41.147-.293.318-.685.523-1.153.158-.362.337-.77.54-1.214.4-.876 1.15-1.624 1.931-2.163.222-.153.438-.284.64-.392l.625 1.6a4.688 4.688 0 101.866-.72l-2.713-6.947a1 1 0 10-1.863.728l1.354 3.466a8.6 8.6 0 00-1.044.618c-.963.665-2.016 1.667-2.615 2.978-.25.545-.436.975-.59 1.328-.133.306-.19.444-.344.772-.153.328-.588.4-.688.395-1.917-.114-2.606 0-2.727 1.514a2.688 2.688 0 01-5.34.157h.036c.007-1.114.14-1.437.594-1.984.453-.547.593-1 .296-1.469-.296-.468-.829-.88-1.671-.093zm18.412 4.095a1 1 0 01-1.296-.568l-.91-2.33a2.688 2.688 0 101.868-.713l.905 2.316a1 1 0 01-.567 1.295z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M9.538 8.002a.225.225 0 00-.199-.116H6.045l.832-3.599a.212.212 0 00-.126-.243.229.229 0 00-.273.072L2.01 10.118a.207.207 0 00-.018.224.225.225 0 00.2.117h3.295l-.833 3.597c-.023.1.03.201.127.243a.229.229 0 00.273-.071L9.52 8.225a.207.207 0 00.017-.223z"
  }));
};

export default SvgBikeElectric;